export default __webpack_public_path__ + "static/media/dmap-seal-purple.1dfa61f2.svg";